<template>
  <section class="section section-blue section-access">

    <div class="container">

      <h2 class="mb-4">
        {{ $t('home.hassleFreeAccess') }}
      </h2>

      <h5 class="sub-heading">
        {{ $t('home.teachTheBibleAccurately') }}
      </h5>

      <div class="row justify-content-md-center mb-5">

        <div class="col-lg-3 mb-4 mb-lg-0">

          <div class="unit">

            <div class="content">

              <img
                src="images/icons/eye.svg"
                class="icon"
                alt="Eye icon"
              />

              <h4>
                {{ $t('home.view') }}
              </h4>

              <p class="mt-4">
                {{ $t('home.viewTheTeachingMaterialOnline') }}
              </p>

            </div>

          </div>

        </div>

        <div class="col-1 text-center text-uppercase d-none d-lg-block unit-join">
          <h5>
            {{ $t('home.or') }}
          </h5>
        </div>

        <div class="col-lg-3 mb-4 mb-lg-0">

          <div class="unit">

            <div class="content">

              <img
                src="images/icons/printer.svg"
                class="icon"
                alt="Printer icon"
              />

              <h4>
                {{ $t('home.print') }}
              </h4>

              <p class="mt-4">
                {{ $t('home.printTheLessonPlan') }}
              </p>

            </div>

          </div>

        </div>

        <div class="col-1 text-center text-uppercase d-none d-lg-block unit-join">
          <h5>
            {{ $t('home.or') }}
          </h5>
        </div>

        <div class="col-lg-3 mb-4 mb-lg-0">

          <div class="unit">

            <div class="content">

              <img
                src="images/icons/people.svg"
                class="icon"
                alt="People icon" />

              <h4>
                {{ $t('home.share') }}
              </h4>

              <p class="mt-4">
                {{ $t('home.shareAUniqueUrl') }}
              </p>

            </div>

          </div>

        </div>

      </div>

      <div class="notice mt-5 d-none d-md-block">

        <a
          href="/register"
          class="btn btn-main btn-outline-light float-end"
          :title="$t('auth.subscribeToFreeTrial')"
        >
          {{ $t("auth.register") }}
        </a>

        <img
          src="images/icons/translate.svg"
          class="icon float-start"
          alt="Translate icon"
          width="65"
        />

        <p>
          {{ $t("home.translatedInto", { languagesCount: 12 }) }}
          <br />
          {{ $t("home.translatedSoFar", { lessonsCount: 150 }) }}
        </p>

      </div>

    </div>

  </section>
</template>

<script>
export default {
  name: "Access",
};
</script>
